export const ROBOTS_PREFIX = 'robots-';

export const robotsClassName = (str: string) => ROBOTS_PREFIX + str;
